import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What software does human resources use?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Human resources departments of different enterprises and organizations normally utilize software like HR management systems or human capital management software. These tools assist in managing employee data, payroll, recruitment, performance assessments, and other roles related to HR Department.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    How much does HR management system cost?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The total cost of an HR management system can change extensively based on the size of your organization, required features, and if you pick an on-location or cloud-based solution. Prices can go from a few hundred dollars per month for small scale businesses to thousands per month for larger organizations.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;